import { render, staticRenderFns } from "./role.view.vue?vue&type=template&id=2b91d234&scoped=true&"
import script from "./role.view.vue?vue&type=script&lang=ts&"
export * from "./role.view.vue?vue&type=script&lang=ts&"
import style0 from "./role.view.vue?vue&type=style&index=0&id=2b91d234&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b91d234",
  null
  
)

export default component.exports